import {Nullable} from '../../../../Common/TypeHelper'
import React from 'react'
import {useLocation} from 'react-router-dom'
import {BucketInfo} from '../../../DTO/BucketInfoDTO'
import {MBMemberError} from '../../../Common/MBMemberError'
import {ExternalLinkButton} from '../../Atoms/Buttons'
import {CompleteMessageContent} from '../../Components/CompleteContentBlocks/CompleteMessageContent'
import {MembersPageTemplate} from '../../Molecules/BaseMembersPages/MembersPageTemplate'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import StepGuide from '../../Molecules/StepGuide/StepGuide'
import {Spacer} from '../../../../Common/Components/Spacer'
import {PIMPageActions} from '../../Atoms/Layouts/PIMPageActions'

export function MembersEditMailMagazineCompletePage(): Nullable<JSX.Element> {
  const location = useLocation<BucketInfo>()
  const locationState: BucketInfo = location.state

  function isInvalidLocationState(
    locationState: BucketInfo,
  ): boolean {
    if (!locationState) {
      return true
    }
    if (!locationState.fcMyPageInfo.url) {
      return true
    }
    // noinspection RedundantIfStatementJS
    if (!locationState.mailMagazineList || locationState.mailMagazineList.length === 0) {
      return true
    }
    return false
  }

  if (isInvalidLocationState(locationState)) {
    throw new MBMemberError('InvalidOperation')
  }

  return (
    <MembersPageTemplate
      hideFooterNavi={true}
      bucketInfo={locationState}
    >
      <PageTitle>メルマガ情報変更完了</PageTitle>

      <StepGuide activity={'edit'} current={'complete'}/>

      <CompleteMessageContent title={'メルマガ情報'} topMessage={'メルマガ'}/>

      <Spacer mt={'30px'}>
        <PIMPageActions>
          <ExternalLinkButton
            label={`${locationState.fcMyPageInfo.name ?? ''}に移動する`}
            url={locationState.fcMyPageInfo.url}
          />
        </PIMPageActions>
      </Spacer>

    </MembersPageTemplate>
  )
}
